<template>
  <button
    @click="$emit('click', $event)"
    :class="['btn', 'btn_type_' + type, { ['btn_align_' + align]: align }]"
    :style="{
      fontWeight: fontWeight,
      height,
      padding: type === 'add' ? '4.5px' : padding,
      width,
      border: !hasBorder ? 'none' : '1px solid inherit',
    }"
    :disabled="disabled"
    :title="tooltip"
    data-placement="top"
    data-toggle="tooltip"
  >
    <svg
      v-if="type === 'add'"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.5 1C4.5 0.723858 4.27614 0.5 4 0.5C3.72386 0.5 3.5 0.723858 3.5 1V3.49976H1C0.723858 3.49976 0.5 3.72361 0.5 3.99976C0.5 4.2759 0.723858 4.49976 1 4.49976H3.5V7C3.5 7.27614 3.72386 7.5 4 7.5C4.27614 7.5 4.5 7.27614 4.5 7V4.49976H7C7.27614 4.49976 7.5 4.2759 7.5 3.99976C7.5 3.72361 7.27614 3.49976 7 3.49976H4.5V1Z"
        fill="white"
      />
    </svg>
    <slot v-else>{{ name }}</slot>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    align: {
      // implemented: 'center'
      type: String,
      default: 'center',
    },
    hasBorder: { default: true, type: Boolean },
    name: { default: '', type: String },
    height: { default: 'auto', type: String },
    padding: {
      type: [String, Number],
      default: '.5rem .75rem',
    },
    fontWeight: {
      type: Number,
      default: 400,
    },
    type: {
      // implemented: 'primary', 'secondary', 'third', 'flat', 'add', 'simple'
      type: String,
      default: 'primary',
    },
    width: { default: 'auto', type: String },
    tooltip: { default: '', type: String },
    disabled: { default: false, type: Boolean },
  },
  emits: {
    click: null,
  },
};
</script>

<style lang="scss" scoped>
@import './Button';
</style>
